<template>
  <div class="list">
    <van-nav-bar
      :title="'重考审核('+list.length+')'"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
    <van-empty v-if="list.length==0" description="暂无重考审核" />
    <van-loading style="text-align: center" type="spinner" v-if="loading" color="#1989fa" />
    <van-row v-for="(item,index) in list" :key="index" class="xitem"   justify="space-between">
      <van-col span="18">
        <p>{{ item.workdesc }}</p>
      </van-col>
      <van-col span="5">
        <span v-if="item.shzt== '0'" class="end" >审核不通过</span>
        <span  v-if="item.shzt== '1'" class="end" >审核通过</span>
        <span  v-if="item.shzt== '2'" class="shzing" >审核中...</span>
        <span   v-if="item.shzt== '3'" class="ing" >未送审</span>
      </van-col>
      <van-col span="24">
        <div
          class="enter"
          @click="enterTest(item.dataid)"
        >审核<van-icon name="arrow" />
        </div>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        list: [],
        loading:true,
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          orderColumn:'shzt',
          orderState:'desc',
        },
      }
    },
    created() {
      this.getcksh();
    },
    methods: {
      onClickLeft() {
        this.$router.push({ name: 'teachmain'})
      },
      enterTest(id) {
        this.$router.push({ name: 'ckshdo', params: { id: id} })
      },
      getcksh() {
        let that = this;
        let data = {params:that.queryParams}
        this.$ajax.get('/examsys/examresitsh/listsh',data).then(function (res) {
          if (res.code == 200) {
            that.list = res.rows;
            that.loading = false;
          }
        })
      },
      beforeClose(action, done) {
        if (action === 'confirm') {

        }else {
          done();
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .list{
    margin-top: 4.125rem;
    padding: 0 1.25rem;
    .xitem{
      background-color: #F8F8F8;
      margin-bottom: .9375rem;
      border-radius: 5px;
      padding: .9375rem 1.25rem;
      h4{
        margin: 0;
        line-height: 1.375rem;
        margin-bottom: .5rem;
      }
      p{
        color: #757DA3;
        font-size: .75rem;
        margin: 0;
        margin-top: .125rem;
        line-height: 1.0625rem;
      }
      .enter{
        color: #757DA3;
        display: flex;
        font-size: .875rem;
        justify-content: space-between;
        padding-top: .9375rem;
        margin-top: .625rem;
        position: relative;
        &::after{
          position: absolute;
          width: calc(100% + 2.5rem);
          left: -1.25rem;
          top: 0;
          content: '';
          height: 1px;
          background-color: #EBEBEB;
        }
      }
      span{
        font-size: .75rem;
        &.ing{
          color: #F86969;
        }
        &.end{
          color: #7469F8;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/teacherpage/ckshindex.vue